import './App.css';
import RumxRating from "./components/RumxRating";
import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
  @import url('https://www.rum-x.com/assets/styles/fonts.css');
`

function App(props) {

  return (
    <div>
      <GlobalStyle />
      <RumxRating rumxid={props.rumxid} ean={props.ean} hideRating={props.hideRating}/>
    </div>
  );
}

export default App;
